import { createContext, type Dispatch } from "react"
import type { RoteirizacaoModel, ProvedorMapa } from "../models/roteirizacaoModel"
import type { RoteirizacaoAction } from "./roteirizacaoActions"

export interface ResultadoAssociacao {
    /** Pedidos efetivamente associados nesta ação (novos + reatribuídos). */
    associados: number
    /** Quantos dos associados eram novos (contam para o limite). */
    novosRoteirizados: number
    /** Pedidos novos que ficaram de fora por estourar o limite. */
    bloqueadosPorLimite: number
    /** O limite foi atingido/estourado nesta ação? */
    limiteAtingido: boolean
    /** Mensagem de erro de validação (ex.: nenhum entregador selecionado). */
    erro?: string
}

export interface RoteirizacaoContextType {
    dados: RoteirizacaoModel
    dispatch: Dispatch<RoteirizacaoAction>
    erroCarregamento: string | null
    provedorMapa: ProvedorMapa
    origem: { lat: number; lng: number } | null
    tokenMapbox: string
    recarregar: () => Promise<void>
    associarSelecionados: () => Promise<ResultadoAssociacao>
}

export const RoteirizacaoContext = createContext<RoteirizacaoContextType | undefined>(undefined)
